export const products = [
  {
    id: 1,
    name: 'Artisan Ceramic Vase',
    description: 'Handcrafted ceramic vase with unique glaze finish, perfect for fresh flowers.',
    price: 45,
    image: 'https://readdy.ai/api/search-image?query=elegant%20handcrafted%20ceramic%20vase%20with%20smooth%20glaze%20finish%20neutral%20earth%20tones%20minimalist%20design%20artisan%20pottery%20on%20simple%20white%20background%20studio%20product%20photography%20soft%20lighting%20high%20quality%20craftsmanship&width=600&height=800&seq=product-ceramic-vase&orientation=portrait'
  },
  {
    id: 2,
    name: 'Organic Cotton Throw',
    description: 'Soft and cozy throw blanket made from 100% organic cotton in natural tones.',
    price: 68,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20organic%20cotton%20throw%20blanket%20folded%20neatly%20natural%20beige%20cream%20color%20soft%20texture%20cozy%20home%20textile%20on%20simple%20white%20background%20studio%20product%20photography%20warm%20lighting%20premium%20quality&width=600&height=800&seq=product-cotton-throw&orientation=portrait'
  },
  {
    id: 3,
    name: 'Scented Soy Candles',
    description: 'Hand-poured soy candles with natural essential oils in elegant glass containers.',
    price: 32,
    image: 'https://readdy.ai/api/search-image?query=elegant%20soy%20candle%20in%20clear%20glass%20jar%20with%20wooden%20lid%20natural%20wax%20cream%20color%20minimalist%20design%20aromatherapy%20candle%20on%20simple%20white%20background%20studio%20product%20photography%20soft%20lighting%20premium%20home%20fragrance&width=600&height=800&seq=product-soy-candle&orientation=portrait'
  },
  {
    id: 4,
    name: 'Leather Journal',
    description: 'Premium leather-bound journal with handmade paper, ideal for writing and sketching.',
    price: 54,
    image: 'https://readdy.ai/api/search-image?query=premium%20leather%20bound%20journal%20notebook%20tan%20brown%20color%20embossed%20cover%20handmade%20paper%20elegant%20stationery%20on%20simple%20white%20background%20studio%20product%20photography%20soft%20lighting%20artisan%20craftsmanship%20quality&width=600&height=800&seq=product-leather-journal&orientation=portrait'
  }
];